import Skeleton from "@shared/components/ui-kit/feedback/Skeleton/Skeleton.web";
import { useTranslation } from "@shared/utils/internationalization";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { BestAvailableSeatingProps } from "../../../../components/SidebarSeatingContainer/SidebarSeatingContainer.props";
import { getUniqueId } from "../../utils/utils";
import BestAvailableSeatingItem from "../BestAvailableSeatingItem/BestAvailableSeatingItem.web";

export default function BestAvailableSeatingBody({
  bestAvailableSeating,
  selectedItemId,
  setSelectedItemId,
  isLoading,
  updateSelectedSeats,
  selectedSeatIds,
}: BestAvailableSeatingProps) {
  const { t } = useTranslation("seating");

  const hasResults = bestAvailableSeating && bestAvailableSeating.length > 0;

  return (
    <Flex
      direction="column"
      data-testid="best-available-seating-body"
      flex="1"
      minHeight="0"
      overflowY="auto"
      gap="md"
      px="md"
      my="none"
      // 80px is the height of the continue button; needed for mobile
      pb={{ base: "6xl", sm: "none" }}
    >
      {!isLoading && (
        <>
          {bestAvailableSeating && hasResults && (
            <Text
              fontSize="lg"
              fontWeight="bold"
              display={{ base: "none", sm: "block" }}
            >
              {t("Select seats")}
            </Text>
          )}
          {bestAvailableSeating && !hasResults && (
            <Text fontSize="md" fontWeight="bold">
              {t(
                "No seats match your selection. Try adjusting the quantity or use the map to pick individual seats."
              )}
            </Text>
          )}

          {bestAvailableSeating?.map((item) => {
            // One of gaInfo or seatingInfo is always present based on data construction
            const itemInfo = (item.gaInfo ?? item.seatingInfo)!;
            return (
              <BestAvailableSeatingItem
                key={getUniqueId(itemInfo)}
                item={item}
                isSelected={Boolean(
                  selectedItemId === getUniqueId(itemInfo) &&
                    selectedSeatIds &&
                    selectedSeatIds.length > 0
                )}
                onSelect={() => {
                  updateSelectedSeats?.();

                  setSelectedItemId?.(
                    selectedSeatIds && selectedSeatIds.length > 0
                      ? getUniqueId(itemInfo)
                      : null
                  );
                }}
              />
            );
          })}
        </>
      )}
      {isLoading && (
        <Flex direction="column" gap="md">
          {Array.from({ length: 10 }).map((_, index) => (
            <>
              {/* eslint-disable-next-line react/no-array-index-key */}
              <Skeleton key={index} height="element.7xl" width="100%" />
            </>
          ))}
        </Flex>
      )}
    </Flex>
  );
}
